<template>
  <Card padding-class="tw-p-4">
    <div class="tw-flex tw-justify-between">
      <div class="tw-text-xs tw-font-semibold tw-uppercase tw-text-neutral-700">
        {{ header }}
      </div>
      <div class="tw-flex tw-items-center tw-space-x-2">
        <InertiaLink
          v-if="viewAllLink"
          :href="viewAllLink"
          class="tw-text-xs tw-text-neutral-500 tw-transition-colors hover:tw-text-neutral-700"
        >
          View all
        </InertiaLink>
        <button
          @click="previous"
          class="tw--m-1 tw-rounded-md tw-p-1 tw-transition-colors hover:tw-bg-neutral-50 disabled:tw-cursor-not-allowed disabled:tw-text-neutral-500 hover:disabled:tw-bg-white"
          :disabled="!hasPreviousIndex"
        >
          <BaseIcon name="arrow-sm-left" class="tw-h-4 tw-w-4" />
        </button>
        <button
          @click="next"
          class="tw--m-1 tw-rounded-md tw-p-1 tw-transition-colors hover:tw-bg-neutral-50 disabled:tw-cursor-not-allowed disabled:tw-text-neutral-500 hover:disabled:tw-bg-white"
          :disabled="!hasNextIndex"
        >
          <BaseIcon name="arrow-sm-right" class="tw-h-4 tw-w-4" />
        </button>
      </div>
    </div>
    <div class="tw-mt-4">
      <BaseCarousel
        :breakpoints="{ 1: { slidesPerView: 1 } }"
        :slides-data="elements"
        :is-navigation-enabled="false"
        :current-slide-index="currentIndex"
      >
        <template #slide="{ slideData }">
          <slot :element="slideData" />
        </template>
      </BaseCarousel>
    </div>
  </Card>
</template>

<script setup lang="ts">
import BaseIcon from '@/shared/components/BaseIcon.vue'
import Card from '@/shared/components/Card.vue'
import { computed, ref } from 'vue'
import BaseCarousel from '@/shared/components/BaseCarousel.vue'

const props = defineProps<{
  header: string
  elements: any[]
  viewAllLink?: string
}>()

const currentIndex = ref(0)
const maxIndex = computed(() => props.elements.length - 1)
const hasNextIndex = computed(() => currentIndex.value < maxIndex.value)
const hasPreviousIndex = computed(() => currentIndex.value > 0)

const next = () => {
  if (!hasNextIndex.value) return
  currentIndex.value++
}

const previous = () => {
  if (!hasPreviousIndex.value) return
  currentIndex.value--
}
</script>
